<div class="filter-modal">
  <div class="filter-header">
    <div class="title-block">
      <mat-icon class="title-icon">filter_alt</mat-icon>
      <h2>Filter by</h2>
    </div>
    <button mat-icon-button class="close-btn" (click)="cancel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="filter-body">
    <div *ngIf="loading" class="loading-state">
      <ngx-skeleton-loader count="6" [theme]="{ height: '52px', 'margin-bottom': '8px' }"></ngx-skeleton-loader>
    </div>

    <div *ngIf="!loading" class="filter-grid">
      <ng-container *ngFor="let slot of slots">
        <ng-container [ngSwitch]="slot.kind">

          <!-- multi-select dropdown backed by a reference table -->
          <mat-form-field
            *ngSwitchCase="'multiSelect'"
            appearance="outline"
            floatLabel="always"
            class="filter-field"
            [class.empty-options]="optionsFor(slot).length === 0"
          >
            <mat-label>{{ slot.label }}</mat-label>
            <mat-select
              [(value)]="selections[slot.key]"
              multiple
              placeholder="All"
              panelClass="finance-filter-search-panel"
              (openedChange)="onSlotPanelOpenedChange($event, $any(slot.key))"
            >
              <mat-select-trigger>
                {{ selectionCount(slot) ? selectionCount(slot) + ' selected' : 'All' }}
              </mat-select-trigger>

              <!--
                In-panel search input. Same pattern as Resource Info's
                Projects filter — (click) + (keydown) stopPropagation so
                mat-select's keyboard nav doesn't intercept typing.
              -->
              <div class="select-search" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                <mat-icon class="select-search-icon">search</mat-icon>
                <input
                  type="text"
                  class="select-search-input"
                  placeholder="Search"
                  [(ngModel)]="slotSearchText[$any(slot.key)]"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                />
                <button
                  *ngIf="slotSearchText[$any(slot.key)]"
                  type="button"
                  mat-icon-button
                  class="select-search-clear"
                  aria-label="Clear search"
                  (click)="slotSearchText[$any(slot.key)] = ''; $event.stopPropagation()"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>

              <mat-option *ngFor="let opt of filteredOptionsFor(slot)" [value]="opt.code">{{ opt.label }}</mat-option>
              <mat-option *ngIf="filteredOptionsFor(slot).length === 0" disabled>
                {{ optionsFor(slot).length === 0
                  ? (slot.key === 'projectIds' ? 'Loaded after Project Catalog ships' : 'No options yet')
                  : 'No matches for "' + slotSearchText[$any(slot.key)] + '"' }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- free-text substring filter -->
          <mat-form-field *ngSwitchCase="'text'" appearance="outline" class="filter-field">
            <mat-label>{{ slot.label }}</mat-label>
            <input matInput type="text" [(ngModel)]="selections[slot.key]" placeholder="Contains…" />
          </mat-form-field>

          <!-- boolean flag rendered as a slide-toggle in-grid -->
          <div *ngSwitchCase="'boolean'" class="filter-toggle">
            <span class="toggle-label">{{ slot.label }}</span>
            <mat-slide-toggle
              [checked]="$any(selections[slot.key])"
              (change)="selections[slot.key] = $event.checked"
              color="primary"
            ></mat-slide-toggle>
          </div>

        </ng-container>
      </ng-container>
    </div>
  </div>

  <div class="filter-footer">
    <button mat-stroked-button class="reset-btn" type="button" (click)="reset()">Reset</button>
    <div class="footer-right">
      <button mat-stroked-button class="cancel-btn" type="button" (click)="cancel()">Cancel</button>
      <button mat-flat-button class="apply-btn" type="button" (click)="apply()">Apply</button>
    </div>
  </div>
</div>
